import _JSXStyle from "styled-jsx/style";
import { useConfig } from '@dhis2/app-runtime';
import React from 'react';
import { LogoImage } from './logo-image.js';
export const Logo = () => {
  const {
    baseUrl
  } = useConfig();
  return /*#__PURE__*/React.createElement("div", {
    "data-test": "headerbar-logo",
    className: "jsx-1445465036"
  }, /*#__PURE__*/React.createElement("a", {
    href: baseUrl,
    className: "jsx-1445465036"
  }, /*#__PURE__*/React.createElement(LogoImage, null)), /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "1445465036"
  }, ["div.jsx-1445465036{box-sizing:border-box;min-width:49px;max-height:48px;margin-block:0;margin-inline-end:12px;margin-inline-start:0;border-inline-end:1px solid rgba(32,32,32,0.15);}", "div.jsx-1445465036:hover{background-color:#1a557f;}", "a.jsx-1445465036,a.jsx-1445465036:hover,a.jsx-1445465036:focus,a.jsx-1445465036:active,a.jsx-1445465036:visited{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;}", "a.jsx-1445465036:focus{outline:2px solid white;outline-offset:-2px;}", "a.jsx-1445465036:focus.jsx-1445465036:not(:focus-visible){outline:none;}"]));
};